export default __webpack_public_path__ + "static/media/eroton.ffbdfc94.png";